export const searchTemplate = () => {
  const $searchTemplate = document.querySelector("section.search-template");
  if ($searchTemplate) {
    const $searchTemplateFilters = $searchTemplate.querySelector(
      ".search-template__filters"
    );
    const $filtersSort = $searchTemplateFilters.querySelector(".filters__sort");
    const $sortSelect = $filtersSort.querySelector(".sort__select");
    $sortSelect.addEventListener("change", (event) => {
      event.preventDefault();

      const searchUrl = new URL(window.location);
      searchUrl.searchParams.set("sort_by", event.target.value);
      window.location = searchUrl.toString();
    });
  }
};

export default searchTemplate;
